// variables
import { DRAWING_SIZE, DRAWING_TEXT_ALIGN } from 'variables';

// libraries
import { atom } from 'recoil';

/** DrawingCaptureAtom - 드로잉 캡쳐 진행여부 */
export const DrawingCaptureAtom = atom({
  key: 'DrawingCaptureAtom',
  default: false
});

/** CapturedImageAtom - 캡쳐한 캔버스 */
export const CapturedImageAtom = atom({
  key: 'CapturedImageAtom',
  default: null
});

/** DrawingCreateModeAtom - 드로잉 생성 모드 */
export const DrawingCreateModeAtom = atom({
  key: 'DrawingCreateModeAtom',
  default: false
});

/** DrawingSaveModalAtom - 드로잉 저장 모달 */
export const DrawingSaveModalAtom = atom({
  key: 'DrawingSaveModalAtom',
  default: false
});

/** DrawingSelectedModeAtom - 드로잉 선택한 모드 */
export const DrawingSelectedModeAtom = atom({
  key: 'DrawingSelectedModeAtom',
  default: null
});

/** DrawingColorAtom - 드로잉 색상 */
export const DrawingColorAtom = atom({
  key: 'DrawingColorAtom',
  default: '#969696'
});

/** DrawingTextListAtom - 드로잉 텍스트 리스트 */
export const DrawingTextListAtom = atom({
  key: 'DrawingTextListAtom',
  default: []
});

/** DrawingTextSelectedAtom - 드로잉 선택한 텍스트 */
export const DrawingTextSelectedAtom = atom({
  key: 'DrawingTextSelectedAtom',
  default: null
});

/** TextAlignmentAtom - 텍스트 정렬 상태 */
export const TextAlignmentAtom = atom({
  key: 'TextAlignmentAtom',
  default: DRAWING_TEXT_ALIGN
});

/** DrawingHistoryAtom - 실행취소 히스토리 */
export const DrawingHistoryAtom = atom({
  key: 'DrawingHistoryAtom',
  default: {
    prev: [],
    current: {
      canvas: null,
      texts: []
    },
    next: []
  }
});

/** DrawingSizeAtom - 드로잉 도구 크기 */
export const DrawingSizeAtom = atom({
  key: 'DrawingSizeAtom',
  default: DRAWING_SIZE.MEDIUM
});

/** DrawingRemoveSizeAtom - 드로잉 지우개 크기 */
export const DrawingRemoveSizeAtom = atom({
  key: 'DrawingRemoveSizeAtom',
  default: DRAWING_SIZE.MEDIUM
});
